import type { ICitaDiagnostico } from '@/modules/Asistencial/interfaces'
import type { IConfMaestra } from '@/modules/Configuracion/interfaces'
import { getMaestra } from '@/modules/Core/usings/generales'
import { pdfTableLayout } from './pdfStyles'

/**
 * Genera la sección de diagnósticos para el PDF usando estilos centralizados.
 * @param items Diagnósticos a mostrar
 * @param maestras Lista de maestras para extraer valores por ID
 * @param options Opciones (puede incluir visible: boolean)
 * @returns Objeto PDF o null si options.visible === false
 */
export function getDiagnosticData(
  items: ICitaDiagnostico[],
  maestras: IConfMaestra[] = [],
  options?: { visible?: boolean }
) {
  if (options && options.visible === false) return null;
  if (!items || items.length === 0) {
    return {
      text: 'Diagnósticos: ',
      style: 'tableHeader',
      margin: [0, 0, 0, 10]
    }
  }

  const body = [
    [
      { text: 'DIAGNOSTICOS', style: 'tableHeader', colSpan: 5 },{},{},{},{}
    ],
    [
      { text: 'CLASIFICACIÓN', style: 'tableHeader' },
      { text: 'CÓDIGO', style: 'tableHeader' },
      { text: 'DESCRIPCIÓN', style: 'tableHeader' },
      { text: 'TIPO DE DIAGNÓSTICO', style: 'tableHeader' },
      { text: 'CLASE', style: 'tableHeader' }
    ],
    ...items.map(d => [
      { text: d.cie10?.dependencia?.comaNombrecorto || '-', style: 'textoCell' },
      { text: d.cie10?.comaNombrecorto || getMaestra(d.cidiTipoCie10 as number, maestras) || `CIE10: ${d.cidiTipoCie10}` || '', style: 'textoCell' },
      { text: d.cie10?.comaNombrelargo || '', style: 'textoCell' },
      { text: d.diagnostico?.comaNombrelargo || getMaestra(d.cidiTipoDiagnostico as number, maestras) || `Tipo: ${d.cidiTipoDiagnostico}` || '', style: 'textoCell' },
      { text: d.clase?.comaNombrelargo || getMaestra(d.cidiTipoClase as number, maestras) || `Clase: ${d.cidiTipoClase}` || '', style: 'textoCell' }
    ])
  ]

  return {
    stack: [
      {
        margin: [0, 5, 0, 0],
        table: {
          headerRows: 1,
          widths: ['auto', 'auto', '*', 'auto', 'auto'],
          body
        },
        layout: pdfTableLayout
      }
    ]
  }
}

export function getDiagnosticDataSimple(
  items: ICitaDiagnostico[],
  options?: { visible?: boolean }
) {
  if (options && options.visible === false) return null;
  if (!items || items.length === 0) {
    return {
      text: 'Diagnósticos:',
      style: 'tableHeader',
      margin: [0, 0, 0, 10]
    }
  }

  return { text: ['Diagnósticos: ', { text: items.map(d =>
    `[${d.cie10?.dependencia?.comaNombrecorto || '-'}] ${d.cie10?.comaNombrecorto}-${d.cie10?.comaNombrelargo}-${d.clase?.comaNombrelargo}`
  ).join('\n') }], style: 'tituloCell' }
}
